import ReactGA from 'react-ga';

import Config from '../../config';

ReactGA.initialize(Config.GA_TRACKING_ID);
// ReactGA.initialize(Config.GA_TRACKING_ID, { debug: true });

ReactGA.set({ appVersion: Config.VERSION_STRING });

export default ReactGA;
